var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSecure(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 1.25C5.77688 1.25 4.375 2.65188 4.375 4.375V6.25H3.75C3.06062 6.25 2.5 6.81063 2.5 7.5V12.5C2.5 13.1894 3.06062 13.75 3.75 13.75H11.25C11.9394 13.75 12.5 13.1894 12.5 12.5V7.5C12.5 6.81063 11.9394 6.25 11.25 6.25H10.625V4.375C10.625 2.65188 9.22312 1.25 7.5 1.25ZM11.25 7.5L11.2513 12.5H3.75V7.5H11.25ZM5.625 6.25V4.375C5.625 3.34125 6.46625 2.5 7.5 2.5C8.53375 2.5 9.375 3.34125 9.375 4.375V6.25H5.625Z",
    fill: "#7A7C7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecure);
export default __webpack_public_path__ + "static/media/secure.c76bc27262478fdd2f720e1d7a0bf6f9.svg";
export { ForwardRef as ReactComponent };